module.exports = "<div class=\"login\">\n    <p class=\"waitingMessage\">Waiting for login details from gust.</p>\n    <a class=\"btn__cancelOauth\" href=\"/login\">Return to Login</a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./~/text-loader!./_src/ui/preLoginApp/login/oauthLogin.html
// module id = 1051
// module chunks = 4